import { createContext } from "react";

const WidgetSettingContext = createContext();

export default WidgetSettingContext;
